export * from './modal-search-patient/modal-search-patient.component';
